import z from 'zod';

const rowWithWorkflowActions = z.object({
  actionRowId: z.string(),
  workflowActions: z.object({
    isInTransientState: z.boolean(),
  }),
});

type RowWithWorkflowActions = z.infer<typeof rowWithWorkflowActions>;

const hasWorkflowAction = (
  dataRow: unknown
): dataRow is RowWithWorkflowActions => {
  return rowWithWorkflowActions.safeParse(dataRow).success;
};

export const getRowIdsForTransientWorkflows = (
  dataRows?: unknown[]
): string[] => {
  return dataRows
    ? dataRows
        .filter(hasWorkflowAction)
        .filter((r) => r.workflowActions.isInTransientState)
        .map((r) => r.actionRowId)
    : [];
};
